import script from "./KColourLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./KColourLine.vue?vue&type=script&setup=true&lang=ts"

import "./KColourLine.vue?vue&type=style&index=0&id=c1f2c598&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f2c598"]])

export default __exports__